(function () {
  'use strict';

  function money(cents) {
    var format = window.themeMoney || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var noDec = key.indexOf('no_decimals') > -1;
    var comma = key.indexOf('comma_separator') > -1;
    var v = (cents / 100).toFixed(noDec ? 0 : 2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    var out = parts.join(comma ? ',' : '.');
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function refreshCartDrawer() {
    var root = (window.themeRoutes && window.themeRoutes.root) || '/';
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'] || '';
        var fresh = tmp.querySelector('#CartDrawer');
        var cur = document.getElementById('CartDrawer');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          cur.classList.add('is-open');
          cur.setAttribute('aria-hidden', 'false');
          document.body.classList.add('is-locked');
        }
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }

  function init(section) {
    var jsonEl = section.querySelector('[data-variants-json]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var idInput = section.querySelector('[data-variant-id]');
    var form = section.querySelector('[data-product-form]');
    var fieldsets = Array.prototype.slice.call(section.querySelectorAll('[data-option-index]'));
    var options = fieldsets.map(function (fs) {
      var legend = fs.querySelector('.option__label');
      var name = legend ? legend.textContent.split(' - ')[0].trim() : '';
      var values = Array.prototype.map.call(fs.querySelectorAll('[data-option-input]'), function (i) { return i.value; });
      return { name: name, values: values };
    });
    /* No variant picker on the page: build options from the product data */
    if (!options.length && variants.length && !(variants.length === 1 && variants[0].title === 'Default Title')) {
      var names = [];
      var optEl = section.querySelector('[data-options-json]');
      try { names = optEl ? JSON.parse(optEl.textContent) : []; } catch (e) { names = []; }
      options = (variants[0].options || []).map(function (_, oi) {
        var vals = [];
        variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) === -1) vals.push(v.options[oi]); });
        return { name: names[oi] || ('Option ' + (oi + 1)), values: vals };
      });
    }

    function currentVariant() {
      var id = idInput ? parseInt(idInput.value, 10) : null;
      return variants.find(function (v) { return v.id === id; }) || variants[0];
    }
    function findByOptions(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }

    /* ---------- Bundle ---------- */
    var bundle = section.querySelector('[data-bundle]');
    var tiers = bundle ? Array.prototype.slice.call(bundle.querySelectorAll('[data-tier]')) : [];

    function selectedTier() { return tiers.find(function (t) { return t.classList.contains('is-selected'); }) || tiers[0]; }

    function renderUnits(tier) {
      var box = tier.querySelector('[data-units]');
      if (!box) return;
      var qty = parseInt(tier.getAttribute('data-qty'), 10);
      if (box.querySelectorAll('.bundle__unit').length === qty) return;
      var base = currentVariant().options;
      var combined = bundle.getAttribute('data-unit-mode') !== 'split';
      var customLabel = bundle.getAttribute('data-units-label');
      box.innerHTML = '';
      if (options.length) { var lbl = document.createElement('span'); lbl.className = 'bundle__units-label'; lbl.textContent = customLabel || options.map(function (o) { return o.name; }).join(' / '); box.appendChild(lbl); }
      for (var u = 0; u < qty; u++) {
        var row = document.createElement('span');
        row.className = 'bundle__unit';
        row.innerHTML = qty > 1 ? '<span class="bundle__unit-num">#' + (u + 1) + '</span>' : '';
        if (combined) {
          var cs = document.createElement('select');
          cs.setAttribute('aria-label', (customLabel || 'Variant') + ' for item ' + (u + 1));
          cs.setAttribute('data-unit-variant', '');
          var cur = currentVariant();
          variants.forEach(function (v) {
            var o = document.createElement('option');
            o.value = String(v.id);
            o.textContent = (v.title || v.options.join(' - ')) + (v.available ? '' : ' (Sold out)');
            if (!v.available) o.disabled = true;
            if (v.id === cur.id) o.selected = true;
            cs.appendChild(o);
          });
          row.appendChild(cs);
          box.appendChild(row);
          continue;
        }
        options.forEach(function (opt, oi) {
          var sel = document.createElement('select');
          sel.setAttribute('aria-label', opt.name + ' for item ' + (u + 1));
          sel.setAttribute('data-unit-option', oi);
          opt.values.forEach(function (val) {
            var o = document.createElement('option');
            o.value = val; o.textContent = val;
            if (val === base[oi]) o.selected = true;
            sel.appendChild(o);
          });
          row.appendChild(sel);
        });
        box.appendChild(row);
      }
    }

    function updateTierPrices() {
      var v = currentVariant();
      var compare = Math.max(v.compare_at_price || 0, v.price);
      tiers.forEach(function (t) {
        var qty = parseInt(t.getAttribute('data-qty'), 10);
        var pct = parseInt(t.getAttribute('data-pct'), 10) || 0;
        var each = v.price - Math.floor(v.price * pct / 100);
        var total = each * qty;
        var totalCompare = compare * qty;
        var totEl = t.querySelector('[data-tier-total]');
        var cmpEl = t.querySelector('[data-tier-compare]');
        var saveEl = t.querySelector('[data-tier-save]');
        var pctEl = t.querySelector('[data-tier-pct]');
        if (pctEl && totalCompare > 0) pctEl.textContent = Math.round((totalCompare - total) * 100 / totalCompare) + '% OFF';
        if (totEl) totEl.textContent = money(total);
        if (cmpEl) { cmpEl.textContent = money(totalCompare); cmpEl.hidden = totalCompare <= total; }
        if (saveEl) saveEl.textContent = totalCompare > total ? 'You save ' + money(totalCompare - total) : '';
      });
    }

    function selectTier(tier) {
      tiers.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        var r = t.querySelector('.bundle__radio');
        if (r) r.checked = on;
        var box = t.querySelector('[data-units]');
        if (box) {
          if (on) renderUnits(t);
          box.hidden = !on;
        }
      });
    }

    if (bundle) {
      tiers.forEach(function (t) {
        t.addEventListener('click', function (e) {
          if (e.target.closest('select')) return;
          if (!t.classList.contains('is-selected')) selectTier(t);
        });
      });
      selectTier(selectedTier());
      updateTierPrices();
    }

    /* When the main variant changes: refresh prices + sync unit #1 */
    section.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      setTimeout(function () {
        updateTierPrices();
        var v = currentVariant();
        var t = selectedTier();
        var first = t && t.querySelector('[data-units] .bundle__unit');
        if (first) {
          var vs = first.querySelector('[data-unit-variant]');
          if (vs) vs.value = String(v.id);
          first.querySelectorAll('[data-unit-option]').forEach(function (sel) {
            sel.value = v.options[parseInt(sel.getAttribute('data-unit-option'), 10)];
          });
        }
        var sticky = document.querySelector('[data-sticky-variant]');
        if (sticky) sticky.value = String(v.id);
      }, 0);
    });

    /* ---------- Add to cart with bundle ---------- */
    if (form && bundle) {
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        e.preventDefault();
        e.stopPropagation();
        var errorEl = section.querySelector('[data-form-error]');
        var addBtn = section.querySelector('[data-add-button]');
        if (errorEl) errorEl.hidden = true;

        var tier = selectedTier();
        var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var lines = {};
        var problem = null;
        var units = tier.querySelectorAll('[data-units] .bundle__unit');
        if (units.length) {
          units.forEach(function (row) {
            var vsel = row.querySelector('[data-unit-variant]');
            var opts, v;
            if (vsel) {
              v = variants.find(function (x) { return String(x.id) === vsel.value; });
              opts = v ? v.options : [vsel.value];
            } else {
              opts = Array.prototype.map.call(row.querySelectorAll('[data-unit-option]'), function (s) { return s.value; });
              v = findByOptions(opts);
            }
            if (!v || !v.available) { problem = opts.join(' / ') + ' is not available'; return; }
            lines[v.id] = (lines[v.id] || 0) + 1;
          });
        } else {
          var cv = currentVariant();
          lines[cv.id] = qty;
        }
        if (problem) {
          if (errorEl) { errorEl.textContent = problem; errorEl.hidden = false; }
          return;
        }
        var items = Object.keys(lines).map(function (id) { return { id: parseInt(id, 10), quantity: lines[id] }; });
        bundle.querySelectorAll('[data-addon-check]:checked').forEach(function (cb) {
          var aid = parseInt(cb.getAttribute('data-addon-variant'), 10);
          if (aid) items.push({ id: aid, quantity: 1 });
        });

        if (addBtn) addBtn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
            return refreshCartDrawer();
          })
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
          .then(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
      }, true);
    }

    /* Changing a dropdown inside a tier shows that variant's photo */
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-unit-variant]');
        if (!sel) return;
        var v = variants.find(function (x) { return String(x.id) === sel.value; });
        if (!v || !v.featured_media_id) return;
        var thumb = section.querySelector('[data-thumb="' + v.featured_media_id + '"]');
        if (thumb) thumb.click();
      });
    }

    /* ---------- Sticky variant select ---------- */
    var stickySel = document.querySelector('[data-sticky-variant]');
    if (stickySel) {
      stickySel.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === stickySel.value; });
        if (!v) return;
        fieldsets.forEach(function (fs, i) {
          fs.querySelectorAll('[data-option-input]').forEach(function (inp) {
            if (inp.value === v.options[i] && !inp.checked) {
              inp.checked = true;
              inp.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      });
    }

    /* ---------- Size chart link opens the accordion ---------- */
    section.querySelectorAll('[data-open-size]').forEach(function (a) {
      a.addEventListener('click', function () {
        var d = document.querySelector(a.getAttribute('href'));
        if (d && d.tagName === 'DETAILS') d.open = true;
      });
    });

    /* ---------- Mini review slider ---------- */
    var mini = section.querySelector('[data-mini-reviews]');
    if (mini) {
      var slides = mini.querySelectorAll('[data-mini-review]');
      var dots = mini.querySelectorAll('[data-mini-dot]');
      var idx = 0;
      var show = function (n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      };
      dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-mini-dot'), 10)); }); });
      if (slides.length > 1) setInterval(function () { show(idx + 1); }, 6000);
    }
  }

  function boot() { document.querySelectorAll('[data-product-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
